import script from "./NotFound.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotFound.vue?vue&type=script&setup=true&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=a8d4f516&lang=scss"

const __exports__ = script;

export default __exports__